define( function() {
	return window.location;
} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/ajax/var/location.js
// module id = 693
// module chunks = 1